import React from 'react';
import './ModalWindow.css'; // Optional: Add styles for the modal
import { Button, Grid, InputLabel, MenuItem, Select, Snackbar, Typography } from '@material-ui/core';

interface ModalWindowProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalWindow: React.FC<ModalWindowProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <div className="modal-header">
          <h3>System message:</h3>
        </div>
        <div className="modal-body">{children}</div>

        <div className="modal-footer">
          <Button variant="outlined" className="modal-button" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalWindow;
